import { message as antMessage } from 'antd';

/**
 * BUG-0101：弹窗内动作失败时，页面内的 inline Alert 会被 Modal 遮罩挡住。
 * 统一走 antd message 顶层提示，保证用户能看到失败原因；调用方仍可保留页面错误状态。
 */
export function notifyActionFailure(text: string): void {
  void antMessage.error(text);
}
